import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import App from './views/App';
import reportWebVitals from './reportWebVitals';
import rootStore from './stores/rootStore';

(async (window) => {
    const initialState = {};
    const store = rootStore(initialState);
    const rootEl = document.getElementById('root');
    const render = (Component, el) => {
        ReactDOM.render(
            <Provider store={store}>
                <Component dispatch={store.dispatch} />
            </Provider>,
            el
        );
    };
    render(App, rootEl);
})(window);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
reportWebVitals();
